import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from '../../core/shared/classes/api';
import { ApiService } from '../../core/services/api.service';
import { Champ } from '../classes/champ';

@Injectable()
export class Z16ProChampService {

    constructor (
        private apiService: ApiService
    ) { }

    getTypesChamp(): Observable<ApiResponse> {
        return this.apiService.get('z16pro/champs/types');
    }

    fetchChamps(entiteId: string): Observable<ApiResponse> {
        return this.apiService.get(`z16pro/entites/${entiteId}/champs`);
    }

    fetchChampsByEntiteCode(code: string): Observable<ApiResponse> {
        return this.apiService.get(`z16pro/entites/${code}/champs`);
    }

    createChamp(data: any): Observable<ApiResponse> {
        return this.apiService.post('z16pro/champs', data);
    }

    updateChamp(champ: Champ): Observable<ApiResponse> {
        return this.apiService.put(`z16pro/champs/${champ.id}`, champ.toJson());

    }

    updateChamps(champ: Array<Champ>) : Observable<ApiResponse> {
        let data = [];
        champ.forEach(champ => {
            data.push(champ.toJson());
        });
        return this.apiService.put(`z16pro/save/champs`, data);
    }

    deleteChamp(champId: string): Observable<ApiResponse> {
        return this.apiService.delete(`z16pro/champs/${champId}`);
    }

}
